<div
  class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 px-4 sm:px-6 pt-5 pb-2 relative">
  <!-- Titre -->
  <h2 class="text-base sm:text-lg font-semibold m-0 pr-8 sm:pr-0">Historique des points fidélité</h2>

  <!-- Boutons d'action -->
  <div class="flex items-center justify-between sm:justify-end w-full sm:w-auto gap-3">
    <!-- Bouton pour consommer les points -->
    <button
      mat-flat-button
      (click)="redeemPoints()"
      [disabled]="loyaltyPoints <= 0"
      class="!bg-[#FF730A] !text-white flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs sm:text-sm rounded-md transition-all cursor-pointer w-full sm:w-auto
         disabled:!bg-gray-300 disabled:!text-gray-500 disabled:!cursor-not-allowed disabled:shadow-none disabled:opacity-100">
      <mat-icon class="material-symbols-outlined !text-lg">shopping_basket</mat-icon>
      <span class="whitespace-nowrap">Consommer mes points</span>
    </button>

    <!-- Bouton Fermer (Positionné en haut à droite sur mobile) -->
    <mat-icon
      class="cursor-pointer material-symbols-outlined text-gray-500 hover:text-black absolute sm:relative top-5 right-4 sm:top-auto sm:right-auto"
      (click)="close()">
      close
    </mat-icon>
  </div>
</div>

<mat-dialog-content class="px-4 sm:px-6 pb-2">

  @if (isLoading()) {
  <div class="flex justify-center items-center min-h-[200px]">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF730A]"></div>
    <span class="ml-2 text-gray-600">Chargement en cours ...</span>
  </div>
  }

  @if (!isLoading() && isEmpty) {
  <div class="flex flex-col justify-center gap-3 items-center">
    <div class="border border-[#00BBA7] bg-[#F0FDFA] rounded-lg px-4 py-3 text-[#00BBA7] text-center">
      <span>Aucun historique de points fidélité 🎖️</span>
    </div>
  </div>
  }

  @if (!isLoading() && !isEmpty) {
  <mat-accordion multi class="loyalty-accordion">
    @for (entry of loyaltyHistory; track entry.id) {
  <mat-expansion-panel>
    <mat-expansion-panel-header class="loyalty-panel-header">
      <mat-panel-title class="!flex-wrap">
        <div class="flex items-center gap-2 flex-wrap">
          <mat-icon class="material-symbols-outlined"
                    [ngClass]="entry.points >= 0 ? 'text-green-600' : 'text-red-500'">
            {{ entry.points >= 0 ? 'add_circle' : 'remove_circle' }}
          </mat-icon>
          <span
            class="font-semibold text-xs sm:text-sm whitespace-nowrap">{{ entry.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
          <span class="text-xs px-2 py-0.5 rounded-full whitespace-nowrap"
                [ngClass]="{
                          'bg-[#fff8f3] text-[#FF730A]': entry.type === 'EARNED',
                          'bg-red-50 text-red-600': entry.type === 'REDEEMED',
                          'bg-[#F0FDFA] text-[#00BBA7]': entry.type === 'ADJUSTMENT'
                      }">
                  {{ entry.typeLabel }}
                </span>
        </div>
      </mat-panel-title>
      <mat-panel-description class="!flex-grow-0 !justify-end">
              <span class="font-bold whitespace-nowrap"
                    [ngClass]="entry.points >= 0 ? 'text-green-600' : 'text-red-500'">
                {{ entry.points >= 0 ? '+' : '' }}{{ entry.points }}
                point{{ (entry.points > 1 || entry.points < -1) ? 's' : '' }}
              </span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="flex flex-col gap-2 py-2">

      <!-- CAS EARNED -->
      @if (entry.type === 'EARNED') {
      @if (entry.metadata?.order) {
      <p class="text-xs text-gray-500 break-words">Commande : {{ entry.metadata.order }}</p>
      }
      @if (entry.metadata?.items?.length > 0) {
      <div class="flex flex-col gap-2">
        @for (item of entry.metadata.items; track item.id) {
        <div class="flex items-center justify-between gap-2 bg-gray-50 rounded-lg px-3 py-2">
          <div class="flex items-center gap-2 min-w-0">
            <mat-icon class="material-symbols-outlined shrink-0 icon-secondary">local_pizza</mat-icon>
            <div class="min-w-0">
              <p class="m-0 font-medium text-gray-800 text-sm truncate">{{ item.name }}</p>
              <p class="m-0 text-xs text-gray-400">Quantité : {{ item.quantity }}</p>
            </div>
          </div>
          <span class="text-xs font-semibold text-[#FF730A] bg-[#fff8f3] px-2 py-1 rounded-full whitespace-nowrap shrink-0">
        {{ item.loyaltyPoints }} point{{ item.loyaltyPoints > 1 ? 's' : '' }}
        </span>
      </div>
        }
      </div>
      }
      }

      <!-- CAS REDEEMED (POINTS UTILISÉS) -->
      @if (entry.type === 'REDEEMED') {
      @if (entry.metadata?.reward?.order) {
      <p class="text-xs text-gray-500 break-words">
        Commande : <span
        class="font-semibold text-gray-700">{{ entry.metadata.reward.order.ref || entry.metadata.reward.order.id || entry.metadata.reward.order }}</span>
      </p>
      }
      @if (entry.metadata?.reward) {
      <div class="flex items-center justify-between gap-2 bg-red-50/50 border border-red-100 rounded-lg px-3 py-2">
        <div class="flex items-center gap-2 min-w-0">
          <mat-icon class="material-symbols-outlined shrink-0 text-red-500">redeem</mat-icon>
          <div class="min-w-0">
            <p class="m-0 font-semibold text-gray-800 text-sm truncate">
              {{ entry.metadata.reward.item?.name || 'Récompense' }}
            </p>
            @if (entry.metadata.reward.percentage > 0) {
            <p class="m-0 text-xs text-red-600">Remise de {{ entry.metadata.reward.percentage * 100 }}%</p>
            }
          </div>
        </div>
        <span class="text-xs font-semibold text-red-600 bg-red-100 px-2.5 py-1 rounded-full whitespace-nowrap shrink-0">
          {{ entry.points }} point{{ (entry.points < -1 || entry.points > 1) ? 's' : '' }}
        </span>
      </div>
      }
      }

      <!-- CAS ADJUSTMENT -->
      @if (entry.type === 'ADJUSTMENT') {
      <div class="flex items-start gap-3 bg-gray-50 rounded-lg px-3 py-3">
        <mat-icon class="material-symbols-outlined icon-secondary shrink-0">chat_bubble_outline</mat-icon>
        <div class="flex flex-col gap-1 min-w-0">
          <p class="m-0 font-medium text-gray-800 text-sm break-words">{{ entry.metadata?.message }}</p>
          @if (entry.metadata?.by?.name) {
      <p class="m-0 text-xs text-gray-400">Par : {{ entry.metadata.by.name }}</p>
      }
      </div>
    </div>
      }

    </div>
  </mat-expansion-panel>
  }
  </mat-accordion>
  }

</mat-dialog-content>

<mat-dialog-actions class="px-4 sm:px-6 pb-4">
  @if (!isLoading() && !isEmpty) {
  <mat-paginator
    class="w-full loyalty-paginator"
    (page)="onPageChange($event)"
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[10, 20, 30, 100]"
    showFirstLastButtons>
  </mat-paginator>
  }
</mat-dialog-actions>
